import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';

@Component({
  selector: 'app-deleting-role',
  templateUrl: './deleting-role.component.html',
  styleUrls: ['./deleting-role.component.css']
})
export class DeletingRoleComponent implements OnInit {
  
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  roleId: number;
  count: number;
  roleData: any;


  @Input() set data(value) {

    if (value != null) {

      console.log('VALUE ID', value);
      
      this.roleId = value.id;
      this.roleInfo(value.id);
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private apiUserOrgService: ApiUserOrgRolesService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
  }


  /**
   * 
   * @param id 
   */
  roleInfo(id) {

    let data = {
      body: {
        id: id,
        mandatory: false
      }
    }

    // this.progressRef.start();

    this.subscriptions.add(
      this.apiUserOrgService.deleteRole(data).subscribe(response => {
        console.log('RESPONSE: 11', response);
      
        if (response != null) {

          if(response.result) {

            for(let i of response.result) {

              this.count = i.count
            }
          } else {
            this.count = null;
          }

          this.roleData = response.result;
        }

        // this.progressRef.complete();
      })
    );
  }


  delete() {

    let data = {
      body: {
        id: this.roleId,
        mandatory: true
      }
    }

    // this.progressRef.start();

    this.subscriptions.add(
      this.apiUserOrgService.deleteRole(data).subscribe(response => {
        console.log('RESPONSE: 11', response);

        if (response != null) {

          this.activeModal.close(true);
        }

        // this.progressRef.complete();
      })
    );
  }

}
